export default "__VITE_ASSET__fcb05808__"